import { useState, useEffect } from 'react';
import { Permission } from '../../types/permissions';
import { permissionUtils } from '../../utils/permissions';

export const usePermissionSelection = (permissions: Permission[]) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const selectPermission = (permissionId: number, checked: boolean) => {
    setSelectedIds(prev => permissionUtils.togglePermission(prev, permissionId, checked));
  };

  const selectAll = (checked: boolean) => {
    if (checked) {
      setSelectedIds(permissionUtils.getPermissionIds(permissions));
    } else {
      setSelectedIds([]);
    }
  };

  const areAllSelected = permissionUtils.areAllPermissionsSelected(permissions, selectedIds);

  // Sincronizar con los permisos del rol cuando cambien
  useEffect(() => {
    setSelectedIds(permissionUtils.getPermissionIds(permissions));
  }, [permissions]);

  return {
    selectedIds,
    selectPermission,
    selectAll,
    areAllSelected
  };
};
